import React from "react";
import axios from "axios";
import { Link } from "react-router";
import FormErrorHandler from "../components/FormErrorHandler";

export default class LoginPasswordReset extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: {},
      valid: true,
      done: false
    };
  }

  handleFormSubmit = () => {
    axios
      .post("/v1/auth/reset-password/confirm/?domain=crs", {
        uidb64: this.props.params.uidb,
        token: this.props.params.passwordtoken,
        new_password1: this.refs.password1.value,
        new_password2: this.refs.password2.value
      })
      .then((response) => {
        this.setState({
          done: true
        });
      })
      .catch((error) => {
        if (error && error.response && error.response.data) {
          this.setState({
            errorMessage: error.response.data
          });
        }
      });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.handleFormSubmit();
  };

  componentDidMount() {
    let postData = {
      uidb64: this.props.params.uidb,
      token: this.props.params.passwordtoken
    };

    axios
      .post("/v1/auth/reset-password/check-token/", postData)
      .then((response) => {
        this.setState({
          valid: response.data.valid
        });
      })
      .catch((error) => {
        if (error && error.response && error.response.data) {
          this.setState({
            errorMessage: error.response.data
          });
        }
      });
  }

  render() {
    let pageContent = (
      <form onSubmit={this.handleSubmit} ref="formref">
        <div className="form-group">
          <label>Je nieuwe wachtwoord</label>
          <input type="password" name="password1" ref="password1" className="form-control form-control-md" required={true} />
        </div>
        <div className="form-group">
          <label>Nogmaals je nieuwe wachtwoord</label>
          <input type="password" name="password2" ref="password2" className="form-control form-control-md" required={true} />
        </div>

        <FormErrorHandler fieldName="all" errorObject={this.state.errorMessage} />

        <FormErrorHandler fieldName="token" errorObject={this.state.errorMessage} />
        <FormErrorHandler fieldName="non_field_errors" errorObject={this.state.errorMessage} />

        <div className="form-group">
          <button className="btn btn-primary" type="submit">
            Opslaan
          </button>
        </div>
      </form>
    );

    let practiceLink = "https://praktijk.nibhv.nl";

    if (this.state.done) {
      return (
        <div className="row justify-content-md-center">
          <div className="form form-signin col-6">
            <div className="section-top">
              <h1>Wachtwoord gewijzigd</h1>
              <p>Je wachtwoord is succesvol aangepast, klik op de onderstaande link om in te loggen.</p>
              <p>
                <Link className="btn btn-primary" to="/">
                  Terug naar inlogscherm
                </Link>
              </p>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="row justify-content-md-center">
          <div className="form form-signin col-6">
            <div className="section-top">
              <h1>Wachtwoord instellen</h1>
              {this.state.valid ? <p>Hieronder kun je opnieuw je wachtwoord instellen.</p> : ""}
            </div>

            {this.state.valid ? (
              pageContent
            ) : (
              <div>
                <div className="alert alert-danger">Helaas, deze link is verlopen en kan niet gebruikt worden om je wachtwoord opnieuw in te stellen.</div>
                <p>
                  <Link className="btn btn-primary" to="/password-lost">
                    Klik hier om opnieuw je wachtwoord in te stellen
                  </Link>
                </p>
              </div>
            )}
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./pages/LoginPasswordReset.js